import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ShowcaseBenefitsContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getBeneficios(id: string): Observable<any> {
    return this.getBeneficiosContents(id).pipe(
      map(res => this.mapBenefits(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryBeneficiosContents[0].data;
  }

  private getBeneficiosContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryBeneficiosContents(filter: "id eq '${id}'") {
          data {
            titulo {
              iv
            }
            subtitulo {
              iv
            }
            links {
              iv {
                titulo
                uRL
                modal {
                  id
                }
              }
            }
            itens {
              iv {
                titulo
                subtitulo
                colunas
                linhas
                modal {
                  id
                }
                imagemFundo {
                  url
                }
                icone {
                  url
                }
                botaoDescricao
                externalLink
                pdf {
                  url
                }
                pagina {
                  data {
                    slug {
                      iv
                    }
                  }
                }
              }
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private mapBenefits(response) {
    let links;
    if (response.links) {
      links = response.links.iv.map(link => {
        return {
          title: link.titulo,
          url: link.uRL,
          modal: link.modal
        };
      });
    }
    const data = response.itens.iv.map(item => {
      const pageRoute =
        item.pagina && item.pagina[0]
          ? '/paginas/' + item.pagina[0].data.slug.iv
          : null;
      return {
        rows: item.linhas,
        cols: item.colunas,
        img: item.imagemFundo ? item.imagemFundo[0].url : null,
        icon: item.icone && item.icone[0] ? item.icone[0].url : null,
        title: item.titulo,
        subtitle: item.subtitulo,
        descriptionActionButton: item.botaoDescricao
          ? item.botaoDescricao
          : null,
        modal: item.modal && item.modal[0] ? item.modal : null,
        page: pageRoute,
        externalLink: item.externalLink ? item.externalLink : null,
        document: item.pdf && item.pdf[0] ? item.pdf[0].url : null,
        buttons: item.botaoDescricao
          ? [
              {
                title: item.botaoDescricao,
                url: null,
                page: null,
                color: 'Texto Primário'
              }
            ]
          : null
      };
    });
    return {
      title: response.titulo?.iv,
      subtitle: response.subtitulo?.iv,
      links,
      data
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
